import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Tabs, TabsList, TabsTrigger } from "./ui/tabs";
import { Container, SectionHeading } from "./primitives";
import { useMarkets } from "../hooks/useMarket";
import { HEATMAP_LIST, pathFor } from "../lib/assets";

const VIEWS = { "24H": { key: "change24h", scale: 4 }, "7D": { key: "change7d", scale: 10 }, "30D": { key: "change30d", scale: 20 } };

export function Heatmap() {
  const { t } = useTranslation();
  const [view, setView] = useState("24H");
  const { data } = useMarkets();
  const bySymbol = Object.fromEntries((data?.markets || []).map((m) => [m.symbol, m]));
  const cfg = VIEWS[view];

  return (
    <section className="py-16 sm:py-20">
      <Container>
        <SectionHeading
          kicker={t("x.heatmap")}
          title={t("x.heatmap")}
          sub={t("x.heatmapSub")}
          action={
            <Tabs value={view} onValueChange={setView}>
              <TabsList className="h-9">
                {Object.keys(VIEWS).map((v) => (
                  <TabsTrigger key={v} value={v} className="num text-xs px-3" data-testid={`heatmap-view-${v}`}>{v}</TabsTrigger>
                ))}
              </TabsList>
            </Tabs>
          }
        />
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-5" data-testid="market-heatmap">
          {HEATMAP_LIST.map((s) => {
            const m = bySymbol[s];
            const val = m ? m[cfg.key] : 0;
            const pos = val >= 0;
            const intensity = Math.min(Math.abs(val) / cfg.scale, 1);
            const bg = `hsl(var(--${pos ? "bullish" : "bearish"}) / ${(0.1 + intensity * 0.55).toFixed(2)})`;
            return (
              <Link
                key={s}
                to={pathFor(s)}
                data-testid={`heatmap-tile-${s}`}
                className="flex flex-col justify-between rounded-md border border-border p-4 transition-transform duration-200 hover:-translate-y-px"
                style={{ backgroundColor: bg }}
              >
                <span className="text-sm font-medium text-foreground">{t(`nav.${s}`, { defaultValue: m?.name || s })}</span>
                <span className="num mt-3 text-lg font-semibold" style={{ color: `hsl(var(--${pos ? "bullish" : "bearish"}))` }}>
                  {val > 0 ? "+" : ""}{m ? val : "—"}%
                </span>
              </Link>
            );
          })}
        </div>
      </Container>
    </section>
  );
}
